<template>
  <div class="propertyWeekInspect">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <!-- 年份下拉框 -->
          <el-select v-model="year" class="select">
            <el-option
              v-for="item in yearList"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 周数下拉框 -->
        <el-form-item>
          <el-select v-model="weekOfYear" class="select">
            <el-option
              v-for="item in weekList"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>     
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="propertyWeekInspectListcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <!-- 问题内容 -->
        <el-table-column prop="content" :label="$t('lang.lab_quesContent')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength23"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.content }}
                </span>
              </div>
              <div>
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength23) | valueIsNull }}
                <span
                  v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength23"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 问题照片 -->
        <el-table-column
          prop="userImgList"
          :label="$t('lang.lab_quesPicture')" width="320px">
          <template slot-scope="scope" >
            <viewer :images="scope.row.userImgList" class="img-width">
              <img v-for="(src,index) in scope.row.userImgList" 
              :src="src"
              :key="index"
              class="img">
            </viewer>
          </template>
        </el-table-column>   
        <!-- 物业回复 -->
        <el-table-column prop="reply" :label="$t('lang.lab_propertyReply')">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.reply&&scope.row.reply.length> require('@/config/enum').tableDatamaxlength23"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.reply }}
                </span>
              </div>
              <div>
                {{ scope.row.reply.substring(0, require('@/config/enum').tableDatamaxlength23) | valueIsNull }}
                <span
                  v-if="scope.row.reply.length>require('@/config/enum').tableDatamaxlength23"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.reply | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 回复照片 -->
        <el-table-column
          prop="staffImgList"
          :label="$t('lang.lab_replyPicture')" width="320px">
          <template slot-scope="scope" >
            <viewer :images="scope.row.staffImgList" class="img-width">
              <img v-for="(src,index) in scope.row.staffImgList" 
              :src="src"
              :key="index"
              class="img">
            </viewer>
          </template>
        </el-table-column>              
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:propertyWeekInspect
 *@Description:物业周检问题
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-12
 */
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      tableData: [],
      multipleSelection: [], // 多选框
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      yearList: [], // 时间列表
      weekList: [], // 周列表
      propertyWeekInspectListcheckbox: require('@/config/enum').propertyWeekInspectListcheckbox, // 是否隐藏复选框
      year: '', // 年
      weekOfYear: '', // 周   
    }
  },
  created() {
    this.initData()
  },
  computed: {
    ...mapGetters(['gardenId'])
  },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.topics()
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 初始化数据
    initData() {
      let loading = this.$loading()
      this.$get(`/selectWeeklyInspection?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.dataList
            this.pageCount = res.pageCount
            // 计算显示年、周的数据
            this.yearList = []
            this.weekList = []
            for (let i = 1; i <= res.weekOfYear; i++) {
               this.weekList.push(i)
            };
            this.yearList.push(res.year)
            this.yearList.push(res.year - 1)
            this.yearList.push(res.year - 2)
            this.year === '' ? this.year = res.year : this.year = this.year
            this.weekOfYear === '' ? this.weekOfYear = res.weekOfYear : this.weekOfYear = this.weekOfYear
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    topics() {
      let loading = this.$loading()
      this.$get(`/selectWeeklyInspection?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}&year=${this.year}&weekly=${this.weekOfYear}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.dataList
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击提交
    submit() {
      this.pageNo = 1
      this.topics()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    }
  }
}
</script>

<style lang="scss">
.propertyWeekInspect{
  .select{
    margin-right:20px;
  }
  .img {
    width: 80px;
    height: 50px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
  }
  .img-width {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 320px;
  }
}
.el-tooltip__popper.is-light {
    max-width: 400px;
  }

</style>